import React from "react";
// import { useUserContext } from "src/contexts/userContext";
import { usePlanContext } from "src/contexts/planContext";
import Company from "src/components/Company";
// import Tree from "src/components/custom/departmentTree";
// import * as API from "src/api/request";

import { DatePicker } from "antd";
import Department from "src/components/custom/departmentTseh";
// import _ from "lodash";

const Header = () => {
  const { state, dispatch } = usePlanContext();

  return (
    <div className="mb-2 pb-2 flex flex-col md:flex-row gap-2 border-b">
      <div className="flex items-center justify-between text-xs gap-2">
        <div className="flex item-center gap-2 ">
          {state.single_page ? (
            <div
              title="Буцах"
              className="px-3 flex items-center justify-center text-blue-700 text-lg border rounded-md cursor-pointer hover:scale-110 duration-300 h-10"
              onClick={() =>
                dispatch({ type: "STATE", data: { single_page: false } })
              }
            >
              <i className="fa fa-arrow-left" />
            </div>
          ) : (
            ""
          )}
        </div>

        <span className="md:w-[50px] font-semibold">Огноо:</span>
        <div className="w-full md:min-w-[200px]">
          {state.report.type === "cash" ? (
            <DatePicker
              allowClear={false}
              className="w-full md:w-[100px] text-xs"
              picker="month"
              format="YYYY.MM"
              value={state.report.date}
              onChange={(date) => {
                dispatch({
                  type: "REPORT",
                  data: { date: date },
                });
              }}
            />
          ) : (
            <div className="flex items-center gap-2">
              <DatePicker
                allowClear={false}
                className="w-full md:w-[100px] text-xs"
                picker="month"
                format="YYYY.MM"
                value={state.report.start_date}
                onChange={(date) => {
                  dispatch({
                    type: "REPORT",
                    data: { start_date: date },
                  });
                }}
              />
              <DatePicker
                allowClear={false}
                className="w-full md:w-[100px] text-xs"
                picker="month"
                format="YYYY.MM"
                value={state.report.end_date}
                onChange={(date) => {
                  dispatch({
                    type: "REPORT",
                    data: { end_date: date },
                  });
                }}
              />
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center w-full md:w-[100px] text-xs gap-2">
        <Company
          value={state.balance.seller_id}
          onChange={(value) => {
            dispatch({ type: "BALANCE", data: { seller_id: value } });
          }}
        />
      </div>

      {/* ✅ Radio buttons section */}
      <div className="flex items-center w-full md:w-[250px] text-xs gap-4">
        <label className="flex items-center gap-1 cursor-pointer">
          <input
            type="radio"
            name="reportType"
            value="cash"
            checked={state.report.type === "cash"}
            onChange={(e) =>
              dispatch({ type: "REPORT", data: { type: e.target.value } })
            }
          />
          <span>Дэлгэрэнгүй</span>
        </label>

        <label className="flex items-center gap-1 cursor-pointer">
          <input
            type="radio"
            name="reportType"
            value="card"
            checked={state.report.type === "card"}
            onChange={(e) =>
              dispatch({ type: "REPORT", data: { type: e.target.value } })
            }
          />
          <span>Нэгдсэн</span>
        </label>
      </div>
    </div>
  );
};
export default Header;
